type ChartConfigEntry = {
  label: string;
  color: string;
};

export const chartConfig: Record<string, ChartConfigEntry> = {
  itemCount: {
    label: "Games",
    color: "hsl(var(--chart-pc))"
  },
  ps1: {
    label: "PS1",
    color: "hsl(var(--chart-sony))",
  },
  ps2: {
    label: "PS2",
    color: "hsl(var(--chart-sony))",
  },
  ps3: {
    label: "PS3",
    color: "hsl(var(--chart-sony))",
  },
  ps4: {
    label: "PS4",
    color: "hsl(var(--chart-sony))",
  },
  psp: {
    label: "PSP",
    color: "hsl(var(--chart-sony))",
  },
  psvita: {
    label: "PS Vita",
    color: "hsl(var(--chart-sony))",
  },
  nec: {
    label: "NEC",
    color: "hsl(var(--chart-nec))",
  },
  pcengine: {
    label: "NEC",
    color: "hsl(var(--chart-nec))",
  },
  pcenginecd: {
    label: "NEC",
    color: "hsl(var(--chart-nec))",
  },
  turbografx16: {
    label: "NEC",
    color: "hsl(var(--chart-nec))",
  },
  turbografxcd: {
    label: "NEC",
    color: "hsl(var(--chart-nec))",
  },
  turboduo: {
    label: "NEC",
    color: "hsl(var(--chart-nec))",
  },
  pcengineturbo: {
    label: "NEC",
    color: "hsl(var(--chart-nec))",
  },
  pc: {
    label: "PC",
    color: "hsl(var(--chart-pc))",
  },
  mastersystem: {
    label: "Sega Master System",
    color: "hsl(var(--chart-sega))",
  },
  megadrive: {
    label: "Sega Mega Drive",
    color: "hsl(var(--chart-sega))",
  },
  segacd: {
    label: "Sega CD",
    color: "hsl(var(--chart-sega))",
  },
  segagamegear: {
    label: "Sega Game Gear",
    color: "hsl(var(--chart-sega))",
  },
  segagenesis: {
    label: "Sega Genesis",
    color: "hsl(var(--chart-sega))",
  },
  segasaturn: {
    label: "Sega Saturn",
    color: "hsl(var(--chart-sega))",
  },
  sega32x: {
    label: "Sega 32X",
    color: "hsl(var(--chart-sega))",
  },
  sega32: {
    label: "Sega 32",
    color: "hsl(var(--chart-sega))",
  },
  segadreamcast: {
    label: "Sega Dreamcast",
    color: "hsl(var(--chart-sega))",
  },
  xbox: {
    label: "XBOX",
    color: "hsl(var(--chart-microsoft))",
  },
  xbox360: {
    label: "XBOX 360",
    color: "hsl(var(--chart-microsoft))",
  },
  xboxone: {
    label: "XBOX ONE",
    color: "hsl(var(--chart-microsoft))",
  },
  xboxseriesx: {
    label: "XBOX SERIES X",
    color: "hsl(var(--chart-microsoft))",
  },
  xboxseriess: {
    label: "XBOX SERIES S",
    color: "hsl(var(--chart-microsoft))",
  },
  gameboy: {
    label: "Nintendo Gameboy",
    color: "hsl(var(--chart-nintendo))",
  },
  gameboyadvance: {
    label: "Nintendo Gameboy Advance",
    color: "hsl(var(--chart-nintendo))",
  },
  n64: {
    label: "Nintendo 64",
    color: "hsl(var(--chart-nintendo))",
  },
  nes: {
    label: "Nintendo NES",
    color: "hsl(var(--chart-nintendo))",
  },
  nesclassic: {
    label: "Nintendo NES Classic",
    color: "hsl(var(--chart-nintendo))",
  },
  nesmini: {
    label: "Nintendo NES Mini",
    color: "hsl(var(--chart-nintendo))",
  },
  superfamicom: {
    label: "Super Famicom",
    color: "hsl(var(--chart-nintendo))",
  },
  snes: {
    label: "SNES",
    color: "hsl(var(--chart-nintendo))",
  },
  gamecube: {
    label: "Nintendo Gamecube",
    color: "hsl(var(--chart-nintendo))",
  },
  wii: {
    label: "Nintendo Wii",
    color: "hsl(var(--chart-nintendo))",
  },
  wiiU: {
    label: "Nintendo Wii U",
    color: "hsl(var(--chart-nintendo))",
  },
  ds: {
    label: "Nintendo DS",
    color: "hsl(var(--chart-nintendo))",
  },
  ds3ds: {
    label: "Nintendo 3DS",
    color: "hsl(var(--chart-nintendo))",
  },
  switch: {
    label: "Switch",
    color: "hsl(var(--chart-nintendo))",
  },
  switch2: {
    label: "Nintendo Switch 2",
    color: "hsl(var(--chart-nintendo))",
  },
  mac: {
    label: "Mac",
    color: "hsl(var(--chart-mac))",
  },
  mobile: {
    label: "Mobile",
    color: "hsl(var(--chart-mobile))",
  },
  arcade: {
    label: "Arcade",
    color: "hsl(var(--chart-arcade))",
  },
  rom: {
    label: "ROM",
    color: "hsl(var(--chart-rom))",
  },
};
